import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyGiftHistory: BaseKeyFunction = () => ["gift-history"];
